import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { CreditTransactionsMain } from '../../organisms/settings/creditTransactions/CreditTransactionsMain';

/**
 * presentations/components/pages/settings/CreditTransactionsPage.tsx
 */
const CreditTransactionsPage: React.FC = () => (
  <SettingsAccessControl allowedRoles='creditViewer'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />
      <SettingsWrapper>
        <CreditTransactionsMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default CreditTransactionsPage;
